<template>
  <div class="virtual-account-container" @click.stop>
    <div
      class="credit-card-container"
      :class="{ expand: isExpand }"
      pointClass="j-open-credit-card"
    >
      <div class="card-container" ref="cardContainer">
        <div
          class="card-item j-credit-card-item credit-card-ico-wrap"
          v-for="(card, index) in creditCardList"
          :class="{ active: curCreditCard === card }"
          :pointValue="card"
          @click="selectCreditCard(card)"
          :key="index"
        >
          <img
            class="pay-way-icon"
            :src="getCurPayWayIcon(card)"
            alt="payway_icon"
          />
          <Icon class="check-icon" name="checked"></Icon>
        </div>
      </div>
      <Icon
        v-show="hasOverflow && !isExpand"
        class="more-icon"
        name="right"
        @click="expandList"
      />
    </div>
  </div>
</template>

<script>
import { PAYTYPE_ICON_URL } from '@utiles/officialStore';
import {
  GET_CARD_SCHEMES_ACTION,
  SET_CREDIT_CARD
} from '@store/officialTopupNew';
import { mapState, mapGetters } from 'vuex';
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';
export default {
  name: 'CreditCard',
  props: {
    curPayType: {
      require: true
    },
    curLocationVal: {
      require: true
    },
    discountTransMount: {
      require: true
    },
    curCoins: {
      require: true
    },
    isCoins: {
      require: true
    }
  },
  data() {
    return {
      isExpand: false,
      containerOverflow: false
    };
  },
  computed: {
    ...mapState({
      creditCardList: state => state.creditCardList,
      curCreditCard: state => state.creditCard,
      letter: state => state.letter
    }),
    ...mapGetters(['cartDiscountTransMount', 'isCart']),
    hasOverflow() {
      return this.containerOverflow && this.creditCardList.length > 0;
    }
  },
  methods: {
    getCurPayWayIcon(cardType) {
      return PAYTYPE_ICON_URL + 'credit_card/' + cardType + '.png';
    },
    selectCreditCard(card) {
      this.$store.commit(SET_CREDIT_CARD, card);
      pushTrackEvent({
        eventName: 'select_credit_card',
        eventValue: {
          credit_type: card
        }
      });
    },
    getCardSchemes() {
      // 金额有三种情况：购物车、非购物车、代币
      let amount = 0;
      if (this.isCart) {
        amount = this.cartDiscountTransMount;
      } else {
        amount = this.isCoins
          ? this.curCoins.TRANS_AMOUNT
          : this.discountTransMount;
      }
      this.$store.dispatch(GET_CARD_SCHEMES_ACTION, {
        currency: this.curPayType.currency,
        game_id: this.$store.state.gameId,
        location: this.curLocationVal,
        amount: amount,
        submit_type: this.isCoins ? 2 : 0 //充值代币余额时传2，否则不传或者传0
      });
    },
    expandList() {
      this.isExpand = true;
    },
    checkOverflow() {
      this.$nextTick(() => {
        if (this.$refs.cardContainer) {
          const container = this.$refs.cardContainer;
          // 检查内容高度是否超过容器的可视高度
          this.containerOverflow =
            container.scrollHeight > container.clientHeight * 1.5;
        }
      });
    }
  },
  created() {
    this.getCardSchemes();
  },
  mounted() {
    this.checkOverflow();
  },
  watch: {
    // 如果使用优惠券则重新请求接口
    discountTransMount() {
      if (this.isCart || this.isCoins) {
        return;
      }
      this.getCardSchemes();
    },
    cartDiscountTransMount() {
      if (this.isCart) {
        this.getCardSchemes();
      }
    },
    curCoins() {
      if (this.isCoins) {
        this.getCardSchemes();
      }
    },
    creditCardList() {
      // 当信用卡列表变化时，检查是否需要显示展开按钮
      this.checkOverflow();
    },
    curLocationVal() {
      this.getCardSchemes();
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.credit-card-container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  padding-right: 20px;
  display: flex;
  flex-direction: column;

  &.expand .card-container {
    overflow: visible;
    height: auto !important;
  }

  .card-container {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 86px;
    margin-bottom: -14px;
    padding-bottom: 14px;
    flex-wrap: wrap;

    .card-item {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 124px;
      height: 74px;
      margin: 10px 8px;
      background-color: #ffffff;
      border: 3px solid #e8e8e8;
      border-radius: 10px;

      &:hover {
        border-color: #191919;
      }

      .check-icon {
        display: none;
        position: absolute;
        right: -15px;
        bottom: -15px;
        width: 28px;
        height: 28px;
        color: $themeColor;
      }
      .pay-way-icon {
        border-radius: 9px;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
      }

      &.active {
        border-color: $themeColor;

        .check-icon {
          display: block;
        }
      }
    }
  }

  .more-icon {
    position: absolute;
    width: 33px;
    height: 52px;
    top: 0;
    bottom: 0;
    right: 22px;
    margin: auto;
  }
}
#ssr-page.landscape {
  .credit-card-container {
    height: 70px;

    &.expand {
      height: auto;
    }

    .card-container {
      .card-item {
        width: 99px;
        height: 58px;

        .check-icon {
          width: 25px;
          height: 25px;
          right: -14px;
          bottom: -14px;
        }
        .pay-way-icon {
          border-radius: 9px;
          width: 100%;
          height: 100%;
          background-color: #ffffff;
        }
      }
    }
    .more-icon {
      right: 14px;
    }
  }
}
</style>
